var e="рік",a="м³",r={year:"рік",qubicMeter:"м³"};export{r as default,a as qubicMeter,e as year};
//# sourceMappingURL=units.js.map